import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepMemberImporter  {
    _originalTypeClassName = "zERP.BO.DepMemberImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepMemberImporter.translate = translateService;
}
this.DepMemberImporterKey = null;
this._key = this.DepMemberImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DepMemberImporterKey:any;
get DepMemberImporterKey(): any {
    return this._DepMemberImporterKey;
  }
set DepMemberImporterKey(value: any) {
    this._DepMemberImporterKey = value;
    this._key = value;
  }

static ParseDepMemberEducation(el: any): any{return (el == "2" ? Domain.DepMemberEducation.SecondStep : ((el == "3" ? Domain.DepMemberEducation.ThirdStep : Domain.DepMemberEducation.No)));
}
static ParseEnlisted(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}
static ParseFamilyStatus(status: any): any{return (status == "ΕΓΓΑΜΟ" ? Domain.FamilyStatus.Married : ((status == "ΔΙΑΖΕΥΓΜΕΝΟ" ? Domain.FamilyStatus.Divorced : ((status == "ΧΗΡΟ" ? Domain.FamilyStatus.Widowed : Domain.FamilyStatus.Single)))));
}
static ParseGeder(el: any): any{return (el == "ΑΝΔΡΑΣ" ? Domain.Gender.Male : ((el == "ΓΥΝΑΙΚΑ" ? Domain.Gender.Female : Domain.Gender.Other)));
}
static ParsePrivateInsurance(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}
static ParseRelationships(status: any): any{return (status == "ΤΕΚΝΟ" ? Domain.Relationship.Child : ((status == "ΣΥΖΥΓΟΣ" ? Domain.Relationship.Spouse : ((status == "ΓΟΝΕΑΣ" ? Domain.Relationship.Parent : Domain.Relationship.Sibling)))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DepMemberImporterKey == null || $this.DepMemberImporterKey == 0;
            }


}